import
  React
from 'react';

import {
  useHistory
} from 'react-router-dom';

import {
  HContainerV,
  Image,
  Text,
  VContainer,
  VContainerVH
} from '@vodacom/web-common';

import {
  handleUtagLinkEvent
} from 'helpers';

import {
  BundleProvider
} from '../../j4u/providers';

import {
  CacheKeys,
  CustomColors,
  Icons
} from 'constants';

import {
  ButtonLink
} from 'components';

export const SocialBundleWidget = () => {

  const history = useHistory();

  const getJ4uOffers = async () => {

    const cachedJ4uOffers = await BundleProvider.getCachedItem(
      CacheKeys.Offers,
      null);

    if (cachedJ4uOffers !== null && cachedJ4uOffers !== 'No offers') {

      setJ4uOffers(true, cachedJ4uOffers.result?.vasList);

      return;
    }

    setJ4uOffers(false, []);

  };

  const setJ4uOffers = (j4uOffers, vasList) => {

    history.push({
      pathname: '/social-bundle',
      state: {
        socialBundleType: 'facebook',
        showJ4u: j4uOffers,
        vasList: vasList
      }
    });

  };

  return (

    <>
    {

        <VContainerVH
          boxShadow={`0px 0px 15px 0px ${CustomColors.TransparentBlack1}`}
          borderRadius={'4px'}
          color={CustomColors.White}
          background={CustomColors.GradientBlue}
          padding={'12px 5px'}>

            <HContainerV
              width={'100%'}
              justifyContent={'space-around'}>

              <VContainer>

                <Text
                  fontSize={'12px'}
                  fontWeight={'700'}
                  lineHeight={'18px'}
                  font={'Roboto'}>
                  {'GO TO  FREE'}
                </Text>

                <Text
                  fontSize={'22px'}
                  fontWeight={'700'}
                  lineHeight={'33px'}>
                  {'Facebook'}
                </Text>

                <ButtonLink
                  width={'200px'}
                  maxWidth={'200px'}
                  margin={'10px -13px 0'}
                  activeColor={CustomColors.White}
                  activeBackgroundColor={CustomColors.Transparent}
                  text={'Find out more'}
                  iconSrc={Icons.TriangleArrow}
                  onClick={() => {

                    handleUtagLinkEvent({
                      event_name: 'campaign_internal_click',
                      link_id: 'cbu: connectu: facebook: find out more'
                    });

                    getJ4uOffers();

                  }}/>

              </VContainer>

              <Image
                src={Icons.FaceBookFlex}
                width={'75px'}
                height={'145px'}/>

            </HContainerV>

        </VContainerVH>
    }
    </>
  );
};